import React, { FC, useEffect, useState } from 'react'

interface Props {
  duration: number
  onResend: () => void
  onStop: () => void
}

export const ResendButton: FC<Props> = ({ duration, onResend, onStop }) => {
  const [secondsLeft, setSecondsLeft] = useState(duration)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    if (duration > 0) setSecondsLeft(duration)
    else return

    const timerId = setInterval(() => {
      setSecondsLeft((seconds) => {
        const newSeconds = seconds > 0 ? seconds - 1 : 0
        if (newSeconds <= 0) {
          clearInterval(timerId)
          onStop()
        }
        return newSeconds
      })
    }, 1000)

    return () => clearInterval(timerId)
  }, [duration, onStop])

  return (
    <button className="user-profile-link-button" disabled={secondsLeft > 0} type="button" onClick={onResend}>
      {secondsLeft > 0 ? `Resend in ${secondsLeft}s` : 'Resend code'}
    </button>
  )
}
